const DefaultCell = ({ value }) => String(value || '');

export default DefaultCell;
